// #region imports

// --- Angular
import { Injectable } from '@angular/core';

// --- RxJs
import { Observable, BehaviorSubject } from 'rxjs';

// --- HS Code
import { AppService } from '../app.service';
import { TermsAndConditionsModel } from '../../../models';

// #endregion

@Injectable({
  providedIn: 'root'
})
export abstract class TermsAndConditionsBaseService {
  protected _isLoaded: boolean = false;

  protected _tacError$: BehaviorSubject<string>;
  get tacError$(): Observable<string> {
    return this._tacError$;
  }

  protected _showHasAcceptedTerms$: BehaviorSubject<boolean>;
  get showHasAcceptedTerms$(): Observable<boolean> {
    return this._showHasAcceptedTerms$.asObservable();
  }

  protected _showEmailOptIn$: BehaviorSubject<boolean>;
  get showEmailOptIn$(): Observable<boolean> {
    return this._showEmailOptIn$.asObservable();
  }

  protected _termsAndConditions$: BehaviorSubject<TermsAndConditionsModel | null>;
  get termsAndConditions$(): Observable<TermsAndConditionsModel | null> {
    return this._termsAndConditions$;
  }

  protected _shouldShowTaCForm$: BehaviorSubject<boolean>;
  get shouldShowTACForm$(): Observable<boolean> {
    return this._shouldShowTaCForm$;
  }

  protected _isUpdating$: BehaviorSubject<boolean>;
  get isUpdating$(): Observable<boolean> {
    return this._isUpdating$;
  }

  constructor(protected appService: AppService) {
    this._tacError$ = new BehaviorSubject<string>('');
    this._termsAndConditions$ = new BehaviorSubject<TermsAndConditionsModel | null>(null);
    this._shouldShowTaCForm$ = new BehaviorSubject<boolean>(false);
    this._showHasAcceptedTerms$ = new BehaviorSubject<boolean>(false);
    this._showEmailOptIn$ = new BehaviorSubject<boolean>(false);
    this._isUpdating$ = new BehaviorSubject<boolean>(false);
  }

  abstract clearState(): void;
  abstract loadUserAgreementPreferences(): void;
  abstract updateUserAgreementSelection(model: TermsAndConditionsModel): void;
  abstract updateUserEmailOptInSelection(model: TermsAndConditionsModel): void;

  showTaCForm(): void {
    this._shouldShowTaCForm$.next(true);
  }

  hideTaCForm(): void {
    this._shouldShowTaCForm$.next(false);
  }
}
